const state = () => ({
    msalConfig: {
        auth: {
            clientId: "e6ccca93-1de7-4579-b14a-aba8f20829f9",
            authority: "https://login.microsoftonline.com/566b5a42-12ce-48e9-84d9-3569a16668f4",
            redirectUri: "https://portail-preprod.akiem.com",
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false
        } 
    },
    accessToken: ''
});

const mutations = {
    setAccesToken(state, token){
        state.accessToken = token
    }
};


const actions = {
    setAccessToken({commit}, value){
        commit("setAccessToken", value)
    }
};

const getters = {

    getAccessToken(state){
        return state.accessToken
    },

    getMsalConfig(state){
        return state.msalConfig;
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}
